// extracted by mini-css-extract-plugin
export var cell = "_6i-4";
export var headerCell = "_6i-2";
export var rowHeader = "_6i-3";
export var table = "_6i-1";
export var tableContainer = "_6i-0";